export const AccountType = {
  OWNER: 1,
  ADMIN: 2,
  MANAGER: 3
};
